import Vue from 'vue'
import Router from 'vue-router'
import Case1 from './views/Case1.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'case1',
      component: Case1
    },
    {
      path: '/case2',
      name: 'case2',
      // route level code-splitting
      // this generates a separate chunk (case2.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "case2" */ './views/Case2.vue')
    },
    {
      path: '/case3',
      name: 'case3',
      component: () => import('./views/Case3.vue')
    }
  ]
})
